import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { vkPushEvent, ymPushEvent, ymPushParams, ymPushWithUrl } from '@fttb/common/utils';
import { sendVkEventAnalytic } from "../../TariffDetailsPage/analytic/orderTariffPopup";
import { CONVERGENT_TARIFF_CONNECT } from "../components/OrderTariffFormPopup/OrderTariffFormOldPopup/analytics/constants";
import { ANALYTIC_PARAMS_VALUES, VkGoalEvent } from "./constants";
var getTextWithoutTags = function getTextWithoutTags(str) {
  return str.replace(/<[^>]+>/gm, ' ');
};
export var sendInfoCardClickAnalytics = function sendInfoCardClickAnalytics(pageType, cardName) {
  return ymPushParams(_defineProperty({}, pageType, {
    page_menu: getTextWithoutTags(cardName)
  }));
};
export var sendCheckAddressToTariffsAnalytics = function sendCheckAddressToTariffsAnalytics(pageType) {
  return ymPushParams(_defineProperty({}, pageType, {
    address_check: 'to_tariffs'
  }));
};
export var sendCheckAddressResultTextAnalytics = function sendCheckAddressResultTextAnalytics(_ref) {
  var addressData = _ref.addressData,
    checkingResult = _ref.checkingResult,
    isConvergent = _ref.isConvergent,
    pageType = _ref.pageType;
  var fullAddress = "".concat(checkingResult, ": ").concat(addressData === null || addressData === void 0 ? void 0 : addressData.city, ", ").concat(addressData === null || addressData === void 0 ? void 0 : addressData.street, ", ").concat(addressData === null || addressData === void 0 ? void 0 : addressData.house, ", ").concat(addressData === null || addressData === void 0 ? void 0 : addressData.flat);
  var addressParam = isConvergent ? 'map_address_check' : 'address_check';
  ymPushParams(_defineProperty({}, pageType, _defineProperty({}, addressParam, fullAddress)));
};
export var sendCheckAddressPhoneClickAnalytics = function sendCheckAddressPhoneClickAnalytics(pageType, isConvergent) {
  ymPushParams(_defineProperty({}, pageType, {
    phone_click: 'map'
  }));
  var keyName = isConvergent ? 'ConvergentPhoneClick' : 'HomeTariffPhoneClick';
  ymPushWithUrl(keyName);
};
export var sendLeavePhoneClickAnalytics = function sendLeavePhoneClickAnalytics(_ref2) {
  var isConvergent = _ref2.isConvergent,
    pageType = _ref2.pageType;
  if (isConvergent) {
    ymPushWithUrl('ConvergentPhoneClick');
  } else {
    ymPushParams(_defineProperty({}, pageType, {
      phone_click: 'banner'
    }));
    ymPushWithUrl('HomeTariffPhoneClick');
  }
};
export var sendTariffsTabsChangeTextAnalytics = function sendTariffsTabsChangeTextAnalytics(_ref3) {
  var pageType = _ref3.pageType,
    commonAnalyticsData = _ref3.commonAnalyticsData,
    tabName = _ref3.tabName,
    blockTitle = _ref3.blockTitle;
  ymPushParams(_defineProperty({}, pageType, _objectSpread(_objectSpread({}, commonAnalyticsData), {}, {
    action: ANALYTIC_PARAMS_VALUES.click,
    item_type: ANALYTIC_PARAMS_VALUES.tab,
    tab_text: tabName,
    object_type: ANALYTIC_PARAMS_VALUES.block,
    block_title: blockTitle
  })));
};
export var sendCallBackPhoneFillAnalytics = function sendCallBackPhoneFillAnalytics(pageType) {
  return ymPushParams(_defineProperty({}, pageType, 'call_back_form_fill'));
};
export var sendCallBackPhoneSubmitAnalytics = function sendCallBackPhoneSubmitAnalytics(pageType, isConvergent) {
  var keyName = isConvergent ? 'ConvergentTariffCallbackShortForm' : 'HomeTariffCallbackForm';
  ymPushParams(_defineProperty({}, pageType, 'call_back_form_submit'));
  ymPushWithUrl(keyName, {
    form_type: 'callback_form'
  });
  vkPushEvent(VkGoalEvent.shpdOrderedACall);
};
export var sendFAQTabClickAnalytics = function sendFAQTabClickAnalytics(pageType, faqTitle) {
  return ymPushParams(_defineProperty({}, pageType, {
    faq: {
      faq_click: faqTitle
    }
  }));
};
export var sendDeviceClickMoreAnalytics = function sendDeviceClickMoreAnalytics(pageType, deviceTitle) {
  return ymPushParams(_defineProperty({}, pageType, {
    device: {
      click: deviceTitle
    }
  }));
};
export var sendDeviceClickAddAnalytics = function sendDeviceClickAddAnalytics(pageType, deviceTitle) {
  return ymPushParams(_defineProperty({}, pageType, {
    device: {
      add: deviceTitle
    }
  }));
};
export var sendTariffsSectionClickAnalytics = function sendTariffsSectionClickAnalytics(_ref4) {
  var group = _ref4.group,
    pageType = _ref4.pageType,
    tariffTitle = _ref4.tariffTitle,
    blockTitle = _ref4.blockTitle,
    commonAnalyticsData = _ref4.commonAnalyticsData;
  sendVkEventAnalytic(group);
  var blockTitleWithoutTags = getTextWithoutTags(blockTitle);
  ymPushParams(_defineProperty({}, pageType, _objectSpread(_objectSpread({}, commonAnalyticsData), {}, {
    action: ANALYTIC_PARAMS_VALUES.click,
    item_type: ANALYTIC_PARAMS_VALUES.element,
    element_title: tariffTitle,
    tab_name: group,
    object_type: ANALYTIC_PARAMS_VALUES.block,
    block_title: blockTitleWithoutTags
  })));
  if (group !== 'homeInternetTvAndMobile') return;
  ymPushParams(_defineProperty({}, pageType, {
    tariff_form_submit: tariffTitle
  }));
  ymPushEvent(CONVERGENT_TARIFF_CONNECT, {
    form: 'tariff_section',
    tariff: tariffTitle
  });
};
export var sendFloatingPhoneClickAnalytics = function sendFloatingPhoneClickAnalytics(isConvergent) {
  var keyName = isConvergent ? 'ConvergentTariffConnect' : 'HomeTariffConnect';
  ymPushEvent(keyName, {
    URL: window.location.href,
    form_type: 'icon'
  });
  vkPushEvent(VkGoalEvent.shpdInitiateCallback);
};
export var sendAnalyticsOnBlockVisibility = function sendAnalyticsOnBlockVisibility(pageType, blockTitle) {
  var blockTitleWithoutTags = getTextWithoutTags(blockTitle);
  ymPushParams(_defineProperty({}, pageType, {
    view_screen: blockTitleWithoutTags
  }));
};
export var sendAnalyticsOnTariffsBlockVisibility = function sendAnalyticsOnTariffsBlockVisibility(_ref5) {
  var pageType = _ref5.pageType,
    commonAnalyticsData = _ref5.commonAnalyticsData,
    elementTitle = _ref5.elementTitle,
    tabName = _ref5.tabName,
    blockTitle = _ref5.blockTitle;
  var blockTitleWithoutTags = getTextWithoutTags(blockTitle);
  ymPushParams(_defineProperty({}, pageType, _objectSpread(_objectSpread({}, commonAnalyticsData), {}, {
    action: ANALYTIC_PARAMS_VALUES.view,
    item_type: ANALYTIC_PARAMS_VALUES.element,
    element_title: elementTitle,
    tab_name: tabName,
    object_type: ANALYTIC_PARAMS_VALUES.block,
    block_title: blockTitleWithoutTags
  })));
};
export var sendActionBarClickAnalytics = function sendActionBarClickAnalytics(isConvergent) {
  var keyName = isConvergent ? 'ConvergentTariffConnect' : 'HomeTariffConnect';
  ymPushEvent(keyName, {
    form_type: 'icon',
    URL: window.location.href
  });
};
export var sendAnalyticsOnHeadingBannerClick = function sendAnalyticsOnHeadingBannerClick(_ref6) {
  var bannerTitle = _ref6.bannerTitle,
    pageType = _ref6.pageType,
    url = _ref6.url;
  ymPushParams(_defineProperty({}, pageType, {
    main_banner_click: _defineProperty({}, bannerTitle, url)
  }));
};
export var sendBlockBannerAnalytics = function sendBlockBannerAnalytics(_ref7) {
  var event = _ref7.event,
    id = _ref7.id,
    name = _ref7.name,
    pageType = _ref7.pageType,
    _ref7$url = _ref7.url,
    url = _ref7$url === void 0 ? 'pop_up' : _ref7$url;
  ymPushParams({
    banners_ev_: _defineProperty({}, event, _defineProperty({}, pageType, {
      position: _defineProperty({}, "carousel_".concat(id), _defineProperty({}, name, url))
    }))
  });
};
export var sendVkCheckAddressEventAnalytics = function sendVkCheckAddressEventAnalytics(connected) {
  var goal = connected ? VkGoalEvent.shpdInitiateAddress : VkGoalEvent.shpdInitiateNotAddress;
  vkPushEvent(goal);
};
export var sendVkDetailsEventAnalyticByTariffTab = function sendVkDetailsEventAnalyticByTariffTab(tariffTabKey) {
  var goal = {
    // TODO пока по ТЗ только для yandex
    yandex: VkGoalEvent.shpdYandexOpenForm
    // homeInternet: VkGoalEvent.shpdOpenForm,
    // homeInternetAndTv: VkGoalEvent.shpdTvOpenForm,
    // presetUp: VkGoalEvent.shpdTvIntOpenForm,
  }[tariffTabKey];
  vkPushEvent(goal);
};